import { render, staticRenderFns } from "./agentBuyCardOrder.vue?vue&type=template&id=3b4bf60b&scoped=true&"
import script from "./agentBuyCardOrder.vue?vue&type=script&lang=js&"
export * from "./agentBuyCardOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b4bf60b",
  null
  
)

export default component.exports